<div
  class="modal fade"
  id="staticConfirmBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticConfirmBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="dialogue-title">{{ this.dialogService.title }}</h4>
      </div>
      <div class="modal-body">
        {{ this.dialogService.message }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn--close"
          id="btn-ok"
          data-bs-dismiss="modal"
          data-bs-dismiss="modal"
          (click)="this.dialogService.closeDialog()"
        >
          Zatvori
        </button>
      </div>
    </div>
  </div>
</div>
